/**
 * BranchCartCheck: check one vendor's cart at its branch when the cart is
 * opened, and show what changed (branch operations, 4 Oct 2026).
 * ─────────────────────────────────────────────────────────────────────────────
 * Mount it inside a cart surface (the restaurant and pharmacy cart drawers,
 * each brand group of the Cart Hub). While `active`, any line that is not yet
 * confirmed at its branch (a cart read back from localStorage, a cart that
 * moved, a live branch change) is checked with the server and, when
 * something changed, the "Changes at <branch>" dialog opens. A failed check
 * shows nothing: the order-create gate is the authority.
 *
 * Renders only the dialog; the cart's own lines stay where they are.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React from "react";
import { useCartBranchCheck } from "../../hooks/useBranchCartCheck";
import BranchCartReviewDialog from "./BranchCartReviewDialog";

/**
 * @param {object}  props
 * @param {"brand"|"restaurant"|"healthcare"} props.vertical
 * @param {string}  props.cartId        the key the cart is stored under
 * @param {string}  [props.vendorId]    the id to quote with (defaults to cartId)
 * @param {string}  [props.locationName]
 * @param {boolean} [props.active=true]
 */
const BranchCartCheck = ({ vertical, cartId, vendorId, locationName, active = true }) => {
  const check = useCartBranchCheck({
    vertical,
    cartId,
    vendorId,
    locationName,
    checkWhen: active,
  });
  return <BranchCartReviewDialog {...check.dialogProps} />;
};

export default BranchCartCheck;
